import { currencies } from '../../../../currencies'
import { CurrencyOption } from '../../../typings'
import type { Texts } from './useTexts'

export const createValidateCurrency = async (texts: Texts, currency: CurrencyOption['value']) => {
  const currencyRequiredError = {
    id: 'currencyRequiredError',
    field: 'currency',
    message: texts.currencyRequired,
    priority: 3,
  }

  const currencyValidError = {
    id: 'currencyValidError',
    field: 'currency',
    message: texts.currencyInvalid,
    priority: 7,
  }

  const empty = currency?.trim().length === 0
  const invalidCurrency = !empty ? !currencies.includes(currency?.trim()) : false

  return {
    [currencyRequiredError.id]: empty ? currencyRequiredError : undefined,
    [currencyValidError.id]: invalidCurrency ? currencyValidError : undefined,
  }
}
